/**
 * TS002: strip an empty productListFilters query param.
 * Leaves populated filter values alone. Runs without a reload.
 * Also wraps history.replaceState so Klevu cannot put the empty param back.
 */
(function () {
  var PARAM = 'productListFilters';

  function valuesAreEmpty(values) {
    if (!values.length) return false;
    for (var i = 0; i < values.length; i++) {
      if (String(values[i] || '').trim() !== '') return false;
    }
    return true;
  }

  function stripEmptyParam(url) {
    if (!url.searchParams.has(PARAM)) return false;
    if (!valuesAreEmpty(url.searchParams.getAll(PARAM))) return false;
    url.searchParams.delete(PARAM);
    return true;
  }

  function cleanedRelative(urlString) {
    var url = new URL(urlString, window.location.href);
    if (url.origin !== window.location.origin) return urlString;
    if (!stripEmptyParam(url)) return urlString;
    return url.pathname + url.search + url.hash;
  }

  function cleanLocation() {
    try {
      var url = new URL(window.location.href);
      if (!stripEmptyParam(url)) return;
      var state = typeof history.state === 'object' && history.state !== null ? history.state : {};
      origReplaceState.call(history, state, '', url.pathname + url.search + url.hash);
    } catch (err) {
      /* ignore malformed URLs */
    }
  }

  function cleanHref(href) {
    try {
      return cleanedRelative(href);
    } catch (err) {
      return href;
    }
  }

  function cleanAnchors(root) {
    if (!root || !root.querySelectorAll) return;
    var links = root.querySelectorAll('a[href*="productListFilters"]');
    for (var i = 0; i < links.length; i++) {
      var next = cleanHref(links[i].getAttribute('href') || '');
      if (next && next !== links[i].getAttribute('href')) {
        links[i].setAttribute('href', next);
      }
    }
  }

  var origReplaceState = history.replaceState;
  history.replaceState = function (state, title, url) {
    if (typeof url === 'string' && url.length) {
      try {
        url = cleanedRelative(url);
      } catch (err) {
        /* keep original url */
      }
    }
    return origReplaceState.call(history, state, title, url);
  };

  var origPushState = history.pushState;
  history.pushState = function (state, title, url) {
    if (typeof url === 'string' && url.length) {
      try {
        url = cleanedRelative(url);
      } catch (err) {
        /* keep original url */
      }
    }
    return origPushState.call(history, state, title, url);
  };

  window.__tsCleanEmptyFilters = cleanLocation;

  cleanLocation();

  if (document.documentElement) cleanAnchors(document.documentElement);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      cleanLocation();
      cleanAnchors(document);
    });
  }

  window.addEventListener('load', cleanLocation);

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('a[href*="productListFilters"]')) {
            var next = cleanHref(node.getAttribute('href') || '');
            if (next && next !== node.getAttribute('href')) node.setAttribute('href', next);
          }
          cleanAnchors(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
